function convertObjectToArray(object) {
  const array = [];
  Object.keys(object).forEach((key) => {
    array.push(object[key]);
  });

  return array;
}

function convertOptionsToArrayOfObjects(options) {
  const array = [];
  options.forEach((option, index) => {
    if (index !== 0) {
      const obj = {
        id: option.value,
        display_name: option.innerText,
        name: option.dataset.name,
        slug: option.dataset.slug,
      };

      array.push(obj);
    }
  });

  return array;
}

/**
 * Goes to a URL
 *
 * @param { String } url
 * @returns { void }
 */
function goToPage(url) {
  window.location.href = url;
}

function mapQuery(select) {
  if (!select.value) {
    return null;
  }

  const selectId = select.id.toLowerCase();
  const selected = select.options[select.selectedIndex];
  const text = encodeURIComponent(selected.dataset.name || selected.innerText);

  const selectIdParamKeyMapping = {
    type: 'categories',
    make: 'makes',
    condition: 'conditions',
    model: 'models',
    'body-style': 'categories',
  };

  // if our mapping doesn't include a key that matches our selectId
  if (!Object.keys(selectIdParamKeyMapping).includes(selectId)) {
    return null;
  }

  return {
    key: selectIdParamKeyMapping[selectId],
    value: `["${text}"]`,
  };
}

export {
  convertObjectToArray,
  convertOptionsToArrayOfObjects,
  goToPage,
  mapQuery,
};
